/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Reference_Dataset_CountryInputs */

const en_reference_dataset_country = /** @type {(inputs: Reference_Dataset_CountryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Countries`)
};

/**
* | output |
* | --- |
* | "Countries" |
*
* @param {Reference_Dataset_CountryInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const reference_dataset_country = /** @type {((inputs?: Reference_Dataset_CountryInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Reference_Dataset_CountryInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_reference_dataset_country(inputs)
});